import { useState } from 'react';
import Page from 'modules/app/components/Page';
import s from './AllProducts.module.scss';
import AllProductsFilter from './AllProductsFilter';
import AllProductsHeader from './AllProductsHeader';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import useGetAllProducts from 'sdk/hooks/shop/useGetAllProducts';
import useIsAuth from 'sdk/hooks/useIsAuth';
import useAddProductToBasket from 'sdk/hooks/shop/useAddProductToBasket';
import useGetAllBrands from 'sdk/hooks/shop/useGetAllBrands';
import Products from '../Services/Products/Products';
import BackHeader from '../BackHeader';

const AllProducts = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data: products } = useGetAllProducts();
  const { data: brands } = useGetAllBrands();
  const { data: isAuthData } = useIsAuth();
  const userId = isAuthData?.user?.id;
  const { mutate: addToBasket } = useAddProductToBasket();
  const location = useLocation();

  const [selectedBrand, setSelectedBrand] = useState('All');
  const [loadingProductId, setLoadingProductId] = useState(null);

  const handleBack = () => {
    const scrollPosition = location.state?.scrollPosition || 0;
    navigate(`/salon/${id}`, {
      state: {
        tab: 6,
        restoreScroll: true,
        scrollPosition: scrollPosition,
        fromBack: true,
      },
      replace: true,
    });
  };

  const filteredProducts = products?.filter(product => {
    if (selectedBrand === 'All') return true;
    const brandObj = brands?.find(b => b.id === product.brand);
    return brandObj?.name === selectedBrand;
  });

  const handleAddToBag = product => {
    if (!userId) {
      navigate('/sign-up');
      return;
    }

    setLoadingProductId(product.id);

    addToBasket(
      {
        createdBy: userId,
        productId: product.id,
        price: product?.price
      },
      {
        onSuccess: () => {
          console.log('Product added successfully');
        },
        onError: error => {
          console.error('Error adding to bag:', error);
        },
        onSettled: () => {
          setLoadingProductId(null);
        },
      },
    );
  };

  return (
    <Page marginBottomNone disableOverflow activeLink="/venues">
      <BackHeader title="Products" onBack={handleBack} />
      <div className={s.all_products_container}>
        <AllProductsFilter selectedBrand={selectedBrand} setSelectedBrand={setSelectedBrand} />
        <Products products={filteredProducts} />
      </div>
    </Page>
  );
};

export default AllProducts;
